<div class="login-logo my-4" *ngIf="!uploading" [style.background-image]="'url(' + logoUrl + ')'"></div>
<app-file-upload
  [(uploadProgress)]="uploadProgress"
  [(uploading)]="uploading"
  [disabled]="false"
  (upload)="uploadLogo($event)"
  [fileTypes]="imageFormats"
  [confirm]="false"
  [multiple]="false"
  [buttonText]="'Change'"
  [icon]="'sync'"
></app-file-upload>
